<template>
    <div class="ui container">
        <div class="ui left aligned">
            <div class="ui form">
                <div class="inline fields">
                    <div class="field">
                        <label>艺人</label>
                        <select v-model="starId" @change="load()">
                            <option value=""></option>
                            <option value="2854373">杨超越</option>
                            <option value="753">刘亦菲</option>
                            <option value="443067">迪丽热巴</option>
                            <option value="29192">赵丽颖</option>
                            <option value="29190">周冬雨</option>
                            <option value="16956">郑爽</option>
                            <option value="28062">杨幂</option>
                            <option value="9912">杨紫</option>
                            <option value="5505">关晓彤</option>
                            <option value="1035596">鞠婧祎</option>
                            <option value="2822829">陆婷</option>
                            <option value="2825632">吴宣仪</option>
                            <option value="2854372">赖美云</option>
                        </select>
                    </div>
                    <a href="https://m.maoyan.com/assist/starassemble/217" target="_blank">活动时间： 3月7日0点-3月14日00点</a>
                    <button @click="refresh()" class="ui primary mini button" id="refresh"><i class="sync icon"></i></button>
                </div>
            </div>

            <vuetable ref="vuetable"
                      :api-url="'/celebrity2/' + starId"
                      :fields="fields"
                      :sort-order="sortOrder"
                      :perPage="16"
                      @vuetable:pagination-data="onPaginationData"
            >
            </vuetable>
            <div class="ui grid">
                <div class="ui left aligned six wide column">
                    <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
                </div>
                <div class="right floated six wide column">
                    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                </div>
            </div>
        </div>
        <div class="ui hidden divider"></div>
        <div class="ui form">
            <div class="inline fields">
                <label>间隔</label>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" name="interval" value="5" v-model="interval" @change="load()">
                        <label>5分钟</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" name="interval" value="15" v-model="interval" @change="load()">
                        <label>15分钟</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" name="interval" value="30" v-model="interval" @change="load()">
                        <label>30分钟</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" name="interval" value="60" v-model="interval" @change="load()">
                        <label>1小时</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" name="interval" value="180" v-model="interval" @change="load()">
                        <label>3小时</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" name="interval" value="360" v-model="interval" @change="load()">
                        <label>6小时</label>
                    </div>
                </div>
            </div>
        </div>
        <v-chart id="chart" :options="options" theme="light"></v-chart>
    </div>
</template>
<style scoped>
    .form {
        padding-top: 15px;
    }

    #refresh {
        margin-left: 24px;
    }
    @media screen and (min-width:960px) {
        #chart {
            width: 900px;
            height: 400px;
        }
    }
</style>
<script>
    import Vuetable from '../table/Vuetable.vue'
    import VuetablePagination from '../table/VuetablePagination.vue'
    import VuetablePaginationInfo from '../table/VuetablePaginationInfo.vue'
    import axios from 'axios'
    import ECharts from 'vue-echarts'

    export default {
        name: 'Celebrity2',
        components: {
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            'v-chart': ECharts
        },
        data () {
            return {
                starId: "",
                interval: 5,
                fields: [
                    {name: 'rank', title: '排名'},
                    {name: 'name', title: '姓名', callback: 'link'},
                    {name: 'count', title: '人气值'},
                    {name: 'inc', title: '差值'},
                    {name: 'time', title: '时间', callback: 'date'},
                ],
                sortOrder: [
                    {
                        field: 'time',
                        direction: 'desc'
                    }
                ],
                options: null
            }
        },
        mounted () {
            this.load();
        },
        methods: {
            onPaginationData (paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage (page) {
                this.$refs.vuetable.changePage(page)
            },
            refresh: function () {
                this.$refs.vuetable.reload();
                this.load();
            },
            load: function () {
                axios.get('/celebrity2/chart/' + this.starId + '?interval=' + this.interval).then(data => {
                    let series = [];
                    let legend = [];
                    for (let item of data.data) {
                        let name = item[0].name;
                        series.push({
                            name: name,
                            type: 'line',
                            data: item.map(e => [e.time, e.inc])
                        });
                        legend.push(name);
                    }
                    this.options =
                        {
                            title: {
                                text: '增幅'
                            },
                            legend: {
                                data: legend
                            },
                            tooltip: {
                                trigger: 'axis'
                            },
                            toolbox: {
                                feature: {
                                    saveAsImage: {}
                                }
                            },
                            xAxis: {
                                type: 'time'
                            },
                            yAxis: {
                                type: 'value'
                            },
                            series: series
                        };
                });
            },
            date: function (value) {
                let date = new Date(value);
                return date.toLocaleString();
            },
            link: function (value, item) {
                return '<a href="https://m.maoyan.com/assist/celebrity/' + item.celebrityId + '?_v_=yes" target="_blank">' + value + '</a>';
            }
        }
    }
</script>
